import React, { useMemo } from "react";
import styled from "styled-components";
import Modal from "../../../../components/Modal";
import { Typography, Grid, Switch } from "@mui/material";
import ContainerBox from "../../../../components/ContainerBox";
import Icon from "../../../../components/Icon";
import Button from "../../../../components/Button";

const MainContainer = styled.div`
  padding-bottom: 40px;
  min-height: 100px;
  width: 100%;
  .numberField {
    margin-top: 20px;
  }
  .responseContainer {
    margin-top: 12px;
    .listItem {
      display: flex;
      flex-direction: row;
      margin-left: 10px;
    }
  }
`;

const FeatureList = ({
  selectedVariant,
  features,
  onCancel,
  onEdit,
  onAddNew,
  onCopy,
  onDelete,
  onActivate,
  isLoading,
}) => {
  const _ = require("lodash");
  const featuresData = useMemo(() => {
    // Group by featureGroup
    const grouped = _.groupBy(features, "groupName");
    // Convert the grouped object to an array
    const nestedArray = Object.keys(grouped).map((key) => ({
      groupName: key,
      features: grouped[key],
    }));
    return nestedArray ?? [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [features]);

  return (
    <Modal
      width={"60%"}
      cancelTitle={"Cancel"}
      onCancel={onCancel}
      isLoading={isLoading}
    >
      <MainContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" fontWeight={700} marginBottom={1}>
            {"Features of " + selectedVariant.name}
          </Typography>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Button label={"Add New"} height={"30px"} onClick={onAddNew} />
            <Button
              style={{ marginLeft: 10 }}
              label={"Copy From"}
              height={"30px"}
              onClick={onCopy}
            />
          </div>
        </div>
        <div style={{ maxHeight: 400, overflow: "auto" }}>
          {featuresData.map((item, index) => {
            return (
              <ContainerBox label={item.groupName}>
                <Grid key={index} container spacing={1}>
                  {item.features.map((childItem, index1) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        justifyContent={"space-between"}
                        display={"flex"}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "90%",
                          }}
                        >
                          <Typography
                            variant="Body1"
                            fontWeight={700}
                            minWidth={"40%"}
                            style={{
                              opacity: childItem.isModelDtlEnabled ? 1 : 0.6,
                            }}
                          >
                            {childItem.featureName}
                          </Typography>
                          <Typography
                            variant="Body1"
                            style={{
                              opacity: childItem.isModelDtlEnabled ? 1 : 0.6,
                            }}
                          >{`: ${childItem.value}`}</Typography>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginRight: 20,
                            width: 80,
                            justifyContent: "flex-end",
                          }}
                        >
                          {childItem.isModelDtlEnabled === 1 && (
                            <div
                              style={{
                                marginRight: "8px",
                                marginLeft: "8px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                onEdit([childItem]);
                              }}
                            >
                              <Icon width={18} height={18} icon="edit" />
                            </div>
                          )}
                          <Switch
                            size="small"
                            checked={childItem.isModelDtlEnabled}
                            onChange={(e) => {
                              if (e.target.checked) {
                                onActivate(childItem);
                              } else {
                                onDelete(childItem);
                              }
                            }}
                          />
                        </div>
                      </Grid>
                    );
                  })}
                </Grid>
              </ContainerBox>
            );
          })}
        </div>
      </MainContainer>
    </Modal>
  );
};

export default FeatureList;
